<template>
    <router-link to="/">
  <section class="flex justify-center items-center flex-col w-max md:flex-row">
        <img 
            class="h-10 w-10"
            src="../assets/logo.svg" 
            alt="brand-logo">
        <h1 class=" font-heading uppercase text-2xl md:ml-0.5">
            blackfit
        </h1>
  </section>
    </router-link>
</template>

<script>
export default {
    name : "BrandLogo"
}
</script>

<style>

</style>